import logo from '@/assets/logo/full_color.png';
import { Image } from '@/components/Image';

interface CardFooterProps {
  year: number;
}

export const CardFooter = ({ year }: CardFooterProps) => (
  <div className="mt-auto border-t border-gray-100 p-6">
    <div className="flex flex-col items-center justify-center gap-4">
      <div className="text-center text-sm text-gray-600">
        Créez votre carte de visite digitale{' '}
        <span className="font-bold text-linko-light">gratuitement</span> en vous
        inscrivant sur{' '}
        <a
          href="https://app.linko-connect.com"
          className="text-linko-dark underline decoration-linko-light underline-offset-4 transition-colors hover:text-linko-light"
        >
          app.linko-connect.com
        </a>
        .
      </div>
      <Image
        src={logo}
        alt="Logo"
        className="w-16 transition-opacity hover:opacity-100"
      />
      <p className="text-sm text-gray-400">
        &copy; {year} Linko. Tous droits réservés.
      </p>
    </div>
  </div>
);
